import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedBottle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 15,
	viewBox: "0 0 8 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.00143 12.164V14H7V6.84222C7 4.84524 5.12652 4.79538 5.12652 4.79538V1H2.87348V4.79538C2.87348 4.79538 1 4.84524 1 6.84222V7.32943C1.00143 8.63363 1.00143 10.6813 1.00143 12.164Z",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M1 8H7" }),
		/* @__PURE__ */ _jsx("path", { d: "M1 11H7" })
	]
});
export default SvgOutlinedBottle;
